module.exports = __webpack_public_path__ + "FixelDisplay-Thin.a864b5a3f11329f4d9b9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelDisplay/FixelDisplay-Thin.woff2
// module id = ./src/assets/webfonts/fixelDisplay/FixelDisplay-Thin.woff2
// module chunks = styles